export default "__VITE_ASSET__B6Gd0I1A__"